import { ChangeDetectionStrategy, ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CurrentData } from "src/app/shared/components/edge/currentdata";
import { NavigationService } from "src/app/shared/components/navigation/service/navigation.service";
import { DataService } from "src/app/shared/components/shared/dataservice";
import { environment } from "src/environments";
import { ChannelAddress, Edge, Service, Websocket } from "../../../shared/shared";

@Component({
    selector: EnergymonitorComponent.SELECTOR,
    templateUrl: "./energymonitor.component.html",
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false,
})
export class EnergymonitorComponent implements OnInit, OnDestroy {
    private static readonly SELECTOR = "energymonitor";
    protected edge: Edge | null = null;
    protected currentData: CurrentData | null = null;
    protected readonly isExcelloTheme = environment.theme === "Excello";

    constructor(
        private service: Service,
        private websocket: Websocket,
        private route: ActivatedRoute,
        private dataService: DataService,
        protected navigationService: NavigationService,
        private zone: NgZone,
        private cdRef: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        this.service.getCurrentEdge().then((edge) => {
            this.edge = edge;

            const essMinMaxChannels = this.edge.isVersionAtLeast("2024.2.2")
                ? [
                      new ChannelAddress("_sum", "EssMinDischargePower"),
                      new ChannelAddress("_sum", "EssMaxDischargePower"),
                  ]
                : [new ChannelAddress("_sum", "EssMaxApparentPower")];

            this.dataService.subscribeChannels(
                [
                    // Ess
                    new ChannelAddress("_sum", "EssSoc"),
                    new ChannelAddress("_sum", "EssActivePower"),
                    ...essMinMaxChannels,
                    // Grid
                    new ChannelAddress("_sum", "GridActivePower"),
                    new ChannelAddress("_sum", "GridMinActivePower"),
                    new ChannelAddress("_sum", "GridMaxActivePower"),
                    new ChannelAddress("_sum", "GridMode"),
                    new ChannelAddress("_sum", "GridBuyPrice"),
                    // Production
                    new ChannelAddress("_sum", "ProductionActivePower"),
                    new ChannelAddress("_sum", "ProductionDcActualPower"),
                    new ChannelAddress("_sum", "ProductionAcActivePower"),
                    new ChannelAddress("_sum", "ProductionMaxActivePower"),
                    // Consumption
                    new ChannelAddress("_sum", "ConsumptionActivePower"),
                    new ChannelAddress("_sum", "ConsumptionMaxActivePower"),
                ],
                edge,
            );

            // Die currentData-Emissionen kommen ueber den Websocket ausserhalb der
            // Angular-Zone an (seit Umstellung auf provideZoneChangeDetection in
            // main.ts). Das bisherige "edge.currentData | async"-Binding im Template
            // loeste dadurch nie eine Change Detection aus: this.edge wurde gesetzt,
            // die View aber nie neu gerendert - das Energiemonitor-Widget blieb beim
            // direkten Anspringen einer Edge leer, bis ein Tab-Wechsel (mit eigener,
            // zone-interner Router-Navigation) eine Neuberechnung erzwang. Gleicher
            // Fix wie in energyflux.component.ts.
            edge.currentData.subscribe(currentData => {
                this.zone.run(() => {
                    this.currentData = currentData;
                    this.cdRef.markForCheck();
                });
            });
        });
    }

    ngOnDestroy() {
        if (this.edge != null) {
            this.edge.unsubscribeChannels(this.websocket, EnergymonitorComponent.SELECTOR);
        }
    }
}
